/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type MemberSearchListAlbumForMemberRequest = {
  groupId: number;
  page?: number;
  perPage?: number | null;
  keyword?: string | null;
  sort?: string | null;
  direction?: MemberSearchListAlbumForMemberRequest.direction | null;
};

export namespace MemberSearchListAlbumForMemberRequest {
  export enum direction {
    ASC = "asc",
    DESC = "desc",
  }
}
